/**
 * Created by Ning Jiang on 2022-07-01.
 */

import {WinPresentationController} from "../WinPresentationController";
import {Serial} from "../../Serial";
import {gsap} from "gsap";
import {SerialSymbolState} from "../../symbol/SerialSymbolConfig";
import {RevealedSymbol} from "../../symbol/RevealedSymbol";
import {IInfectiousWays} from "../../server/data/ISerialData";
import {InfectiousSymbol} from "../../symbol/InfectiousSymbol";
import {SerialSound} from "../../sound/SerialSound";

export class InfectiousWaysControl extends WinPresentationController {

    constructor() {
        super("InfectiousWaysControl", false);
    }

    protected hasWin():boolean {
        return Serial.model.parsedGameData.infectiousWays && Serial.model.parsedGameData.infectiousWays.length > 0;
    }

    protected async createWinAnimation():Promise<any> {
        const tl = gsap.timeline();
        Serial.model.parsedGameData.infectiousWays.forEach(infectious => {
            const symbol = <InfectiousSymbol>Serial.getSymbol(infectious.reel, infectious.row);
            if(symbol.symbolName != infectious.symName) {
                debugger;
                throw new Error(`InfectiousWaysControl:get infectious symbol doesn't match infectious data`);
            }
            tl.add([
                symbol.showInfectious(infectious.row === 0),
                () => {SerialSound.soundPlayer.playTrack({name : SerialSound.INFECTIOUS_LAND})}
            ]);
            const timePosition = 0.5;// tl.totalDuration();
            if(infectious.coords && infectious.coords.length > 0) {
                infectious.coords.forEach(coord => {
                    tl.add(this.revealSymbol(infectious, coord), timePosition);
                });
                tl.add(() => {SerialSound.soundPlayer.playTrack({name : SerialSound.INFECTIOUS_INFECT})}, timePosition);
            } else {
                tl.add(symbol.getStateAnimation(
                    SerialSymbolState.NO_WIN,
                    {duration : 0.1, alpha : 1},
                    {duration : 0.1, alpha : 0}
                ), timePosition);
            }
        });

        return Promise.resolve(tl);
    }

    private revealSymbol(infectious:IInfectiousWays, coord:[number, number]):TimelineLite {
        const infectSymbol = Serial.getSymbol(coord[0], coord[1]);
        if(infectSymbol.symbolName != infectious.symName) {
            debugger;
            throw new Error(`InfectiousWaysControl:symbol ${coord[0]}, ${coord[1]} doesn't match infectious symbol name!`);
        }
        const symbolSize = infectious.multi;
        if(symbolSize > 4) {
            debugger;
            throw new Error(`InfectiousWaysControl:symbol ${coord[0]}, ${coord[1]} ways is bigger than 4!`);
        }
        const reveal = new RevealedSymbol(infectSymbol.symbolName, coord[0], infectSymbol.symbolHeight, symbolSize);
        const revealTl = gsap.timeline();
        revealTl.add(() => {
            Serial.reels[coord[0]].replaceSymbol(reveal, coord[1] - 2);
            infectSymbol.onRemove();
            Serial.ways.updateWays(coord[0], coord[1], symbolSize);
        });
        revealTl.add(gsap.to(reveal.scale, {x : 1.1, y : 1.1, duration : 0.1}));
        revealTl.add(gsap.to(reveal.scale, {x : 1, y : 1, duration : 1}));
        revealTl.add(reveal.playInfectious(), 0);

        return revealTl;
    }
}